import { Controller } from "@hotwired/stimulus"

// Must match Administration::GeocodingQueueStream::REFRESH_SIDEBAR_COUNTS_EVENT
const REFRESH_SIDEBAR_COUNTS_EVENT = "admin:refresh-sidebar-counts"

// Refreshes sidebar (…) counts after admin workspace Turbo Frame loads — e.g. after create redirect.
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.skipWorkspaceFrameLoads = 1
    this.boundOnFrameLoad = this.onFrameLoad.bind(this)
    this.boundOnSidebarRefresh = this.onSidebarRefresh.bind(this)
    document.addEventListener("turbo:frame-load", this.boundOnFrameLoad)
    document.addEventListener(REFRESH_SIDEBAR_COUNTS_EVENT, this.boundOnSidebarRefresh)
  }

  disconnect() {
    document.removeEventListener("turbo:frame-load", this.boundOnFrameLoad)
    document.removeEventListener(REFRESH_SIDEBAR_COUNTS_EVENT, this.boundOnSidebarRefresh)
  }

  onSidebarRefresh() {
    this.refresh()
  }

  onFrameLoad(event) {
    if (event.target.id !== "admin-workspace") return
    if (this.skipWorkspaceFrameLoads > 0) {
      this.skipWorkspaceFrameLoads -= 1
      return
    }
    this.refresh()
  }

  async refresh() {
    if (!this.hasUrlValue || !this.urlValue) return

    let response
    try {
      response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" },
        credentials: "same-origin"
      })
    } catch {
      return
    }

    if (!response.ok) return

    let payload
    try {
      payload = await response.json()
    } catch {
      return
    }

    const counts = payload.counts
    if (!counts || typeof counts !== "object") return

    const formatter = new Intl.NumberFormat("en-US")

    this.element.querySelectorAll("[data-sidebar-count-path]").forEach((el) => {
      const path = el.getAttribute("data-sidebar-count-path")
      if (!path || !(path in counts)) return
      const n = counts[path]
      if (typeof n !== "number") return
      el.textContent = `(${formatter.format(n)})`
    })
  }
}
